import { qnBlueGrey, qnNeutrals, qnTexts } from '../themes/_palette';
export const MuiCssBaseline = {

    styleOverrides: {
        'body *': {
            '@supports not selector(::-webkit-scrollbar)': {
                scrollbarColor: `${qnNeutrals.lightGrey} ${qnBlueGrey[50]}`,
                scrollbarWidth: 'thin',
            },
            "&::-webkit-scrollbar, & *::-webkit-scrollbar": {
                borderTopRightRadius: 8,
                borderBottomRightRadius: 8,
                height: 8,
                width: 8,
                backgroundColor: qnNeutrals.lightGreyBG
            },
            "&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb": {
                borderRadius: 8,
                width: '5px',
                backgroundColor: qnNeutrals.lightGrey,
                minHeight: 24,
                border: `1px solid ${qnBlueGrey[50]}`
            },
        },
        body: {
            ".MuiTypography-h1": {
                fontSize: '1rem',
                fontWeight: 'bold'
            },
            ".MuiTypography-h2": {
                fontSize: '0.875rem',
                fontWeight: 'bold'
            },
            "& .MuiTypography-root": {
                color: 'var(--mui-palette-primary-textColor)'
            },
            ".MuiSkeleton-root":{
                borderRadius: '4px/6.7px',
                background: 'var(--mui-palette-primary-disabled)'
            },
            '.MuiFormHelperText-root': {
                color: 'var(--mui-palette-secondary-textIconColor)',
                fontSize: '0.75rem'
            }
        }
    }
}
